import { Alert } from "antd"
import dayjs from "dayjs"
import parsePhoneNumber from "libphonenumber-js"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styled from "styled-components"

import AppButton from "../../AppButton"
import AppDateInput from "../../FormItems/AppDatePicker"
import AppInput from "../../FormItems/AppInput"

// ----------------------------------------------------------------------------

function _BookingMetaForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const {
        className,
        values,
        onChange,
        foundBooking,
        slot,
        onTimeExpired,
        lockBirth,
    } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [remainingTime, setRemainingTime] = useState()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        /** @type {HTMLInputElement} */
        const input = document.querySelector("#phone-input input")
        const number = values.phone
        if (!number) {
            return
        }
        const parsedNumber = parsePhoneNumber(number, "IT")
        if (parsedNumber && parsedNumber.isValid()) {
            input.setCustomValidity("")
        } else {
            input.setCustomValidity("Inserisci un numero di telefono corretto.")
        }
        //eslint-disable-next-line
    }, [values.phone])

    useEffect(() => {
        const { email, emailRepeat } = values
        /** @type {HTMLInputElement} */
        const input = document.querySelector("#email-repeat-input input")
        if (email && emailRepeat && email !== emailRepeat) {
            input.setCustomValidity("Gli indirizzi non cambaciano.")
            return
        }
        input.setCustomValidity("")

        //eslint-disable-next-line
    }, [values.email, values.emailRepeat])

    useEffect(() => {
        const interval = setInterval(() => {
            if (!slot?.lockedStatus?.lockedAt) return

            const lockExpiretime = dayjs(slot.lockedStatus.lockedAt).add(
                10,
                "minutes"
            )

            if (lockExpiretime.isBefore(dayjs(), "seconds")) {
                onTimeExpired()
            }

            const time = Math.abs(dayjs().diff(lockExpiretime, "seconds"))
            const minutes = Math.floor(time / 60)
            const seconds = time - minutes * 60
            const timeStr = `${minutes} minuti e ${seconds} secondi`
            setRemainingTime(timeStr)
        }, 500)
        return () => clearInterval(interval)
        // eslint-disable-next-line
    }, [slot])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleValueChange(field) {
        return (e) => {
            onChange && onChange(field, e.target.value)
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div className="form-card">
                {remainingTime && (
                    <Alert
                        className="time-alert"
                        message={`Lo slot che hai scelto verrà bloccato ad altri utenti per ${remainingTime}`}
                        type="success"
                    ></Alert>
                )}
                <div className="card-row">
                    <AppInput
                        label="Nome"
                        className="form-input"
                        value={values?.name}
                        onChange={handleValueChange("name")}
                        required
                    />
                    <AppInput
                        label="Cognome"
                        className="form-input"
                        value={values?.lastName}
                        onChange={handleValueChange("lastName")}
                        required
                    />
                </div>
                <div className="card-row">
                    <AppInput
                        label="E-mail"
                        className="form-input"
                        type="email"
                        value={values?.email}
                        onChange={handleValueChange("email")}
                        required
                    />
                    <AppInput
                        label="Ripeti e-mail"
                        className="form-input"
                        type="email"
                        value={values?.emailRepeat}
                        onChange={handleValueChange("emailRepeat")}
                        required
                        id="email-repeat-input"
                    />
                </div>
                <div className="card-row">
                    <AppInput
                        label="telefono"
                        className="form-input"
                        type="tel"
                        id="phone-input"
                        value={values?.phone}
                        onChange={handleValueChange("phone")}
                        required
                    />
                    <AppInput
                        label="Residenza"
                        className="form-input"
                        value={values?.residence}
                        onChange={handleValueChange("residence")}
                        required
                    />
                </div>
                <div className="card-row">
                    <AppDateInput
                        label="Data di nascita"
                        className="form-date"
                        value={values?.birth}
                        onChange={handleValueChange("birth")}
                        disabled={lockBirth}
                    />
                </div>
                <div className="buttons">
                    <AppButton
                        uxType="primary"
                        htmlType="submit"
                        className="submit-btn"
                    >
                        {foundBooking ? "Modifica" : "Conferma"}
                    </AppButton>
                </div>
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_BookingMetaForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onChange: PropTypes.func,
    foundBooking: PropTypes.bool,
    slot: PropTypes.object,
    onTimeExpired: PropTypes.func,
    lockBirth: PropTypes.bool,
}

_BookingMetaForm.defaultProps = {}

// ----------------------------------------------------------------------------

const BookingMetaForm = styled(_BookingMetaForm)`
    & {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .form-card {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            width: 100%;
            padding: 0px 55px;
            border-radius: 24px;
            box-shadow: 0px 6px 35px ${({ theme }) => theme.colors.shadowColor};
            width: 800px;
            height: 500px;
            .time-alert {
                width: 100%;
                margin-bottom: 10px;
            }
            .card-row {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .form-input {
                    width: 320px;
                }
            }
            .submit-btn {
                width: 190px;
                /* margin-top: 20px; */
                height: 50px;
                margin: 20px;
            }
        }

        @media (max-width: 980px) {
            .form-card {
                width: 100%;
                height: 800px;
                justify-content: center;
                .card-row {
                    flex-direction: column;
                    align-items: flex-start;
                    margin: 0;
                    .app-input {
                        width: 100%;
                        margin: 15px 0px;
                    }
                    .form-date {
                        margin: 15px 0px;
                    }
                }
            }
        }
        @media (max-width: 576px) {
            .form-card {
                padding: 0;
                height: 830px;
                box-shadow: none;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default BookingMetaForm
